import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFloatingFilterComponent, CustomFloatingFilterViewModel } from '../ag-floating-filter.component';
import { ICombinedSimpleModel, TextFilterModel } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { GxInputDirective } from '../../../../directives/gxinput.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { LetDirective } from '@ngrx/component';

export type ISimpleFilterModelType = 'empty' | 'equals' | 'notEqual' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual' | 'inRange' | 'contains' | 'notContains' | 'startsWith' | 'endsWith' | 'blank' | 'notBlank';

export interface TextFloatingFilterViewModel extends CustomFloatingFilterViewModel {
  backgroundClassName?: string;
}

@Component({
    selector: 'app-ag-text-floating-filter',
    templateUrl: 'ag-text-floating-filter.component.html',
    styleUrls: ['../ag-list-floating-filter/ag-list-floating-filter.component.scss',
                'ag-text-floating-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        LetDirective,
        MatFormField,
        MatInput,
        FormsModule,
        GxInputDirective,
        ReactiveFormsModule,
        MatIconButton,
        MatSuffix,
        MatIcon,
        TranslateModule,
    ],
})
export class AgTextFloatingFilterComponent extends AgFloatingFilterComponent {
  public override viewModel$: Observable<TextFloatingFilterViewModel> =
      this._viewModel$.asObservable().pipe(map((viewModel) => ({
        ...viewModel,
        backgroundClassName: this.getBackgroundClassName(viewModel.filterModel)
      })));

  readonly isTextFloatingFilter = true;

  constructor() {
    super();
  }

  protected override setFormControlValueFromParentFilterModel(filterModel: TextFilterModel | ICombinedSimpleModel<TextFilterModel>) {
    this.params.parentFilterInstance(filterInstance => {
      if (filterInstance?.getModelAsString) {
        this.setFormControlValueProgrammatically(filterInstance?.getModelAsString(filterModel));
      } else {
        console.error('Missing getModelAsString on parent filter class');
      }
    });
  }

  protected override getDefaultType(): ISimpleFilterModelType {
    return 'contains';
  }

  protected getBackgroundClassName(filterModel: TextFilterModel | ICombinedSimpleModel<TextFilterModel>) {
    if (!filterModel) return '';

    const isCombinedSimpleModel = 'conditions' in filterModel;
    const isNegativeFilter = (type: ISimpleFilterModelType) => {
      return type === 'notEqual' || type === 'notContains';
    }

    if (!isCombinedSimpleModel) {
      if (isNegativeFilter((filterModel as TextFilterModel).type)) {
        return 'red';
      } else {
        return 'green';
      }
    }

    else {
      if (filterModel.conditions.every((condition) => isNegativeFilter(condition.type))) {
        return 'red'
      } else if (filterModel.conditions.every((condition) => !isNegativeFilter(condition.type))) {
        return 'green';
      } else if (isNegativeFilter(filterModel.conditions[0].type)) {
        return 'redGreen';
      } else {
        return 'greenRed';
      }
    }
  }


}
